import React from 'react';

interface FormInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  type?: 'text' | 'email' | 'tel' | 'number';
  className?: string;
  inputClassName?: string;
  labelPosition?: 'above' | 'below';
  tooltip?: string;
}

export const FormInput: React.FC<FormInputProps> = ({
  label,
  value,
  onChange,
  placeholder = '',
  disabled = false,
  type = 'text',
  className = '',
  inputClassName = '',
  labelPosition = 'above',
  tooltip
}) => {
  return (
    <div className={className}>
      {labelPosition === 'above' && (
        <label className="block text-slate-700 font-semibold mb-1.5 text-[11px] 2xl:text-xs 3xl:text-sm">
          {label}
          {tooltip && (
            <span className="relative ml-1 inline-block group/tip">
              <svg className="w-3 h-3 3xl:w-3.5 3xl:h-3.5 inline text-slate-400 cursor-help" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 px-2 py-1 text-[10px] 3xl:text-[11px] font-normal text-white bg-slate-800 rounded-md whitespace-nowrap opacity-0 pointer-events-none group-hover/tip:opacity-100 transition-opacity duration-150 shadow-lg">
                {tooltip}
              </span>
            </span>
          )}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className={`w-full px-3 py-2 border border-slate-300 rounded-lg text-[11px] 2xl:text-xs 3xl:text-sm text-slate-900 placeholder:text-[10px] 2xl:placeholder:text-[11px] 3xl:placeholder:text-xs focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300 disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed ${inputClassName}`}
      />
      {labelPosition === 'below' && (
        <label className="block text-[10px] 2xl:text-[11px] 3xl:text-xs lowercase text-slate-600 font-bold mt-1">
          {label}
        </label>
      )}
    </div>
  );
};
